const ValidationError = require('./errors/ValidationError');
const { banks, errors } = require('@transfeeradev/api-enums');
const Default = require('./Default');

module.exports = class NuPagamentos extends Default {
  constructor(data) {
    super('NuPagamentos', data, banks.NU_PAGAMENTO.code);
    this._data.agency = this._removeUnnecessaryLeadingZeros(this._data.agency, this._agencySchemaLength);
    this._data.account = this._removeUnnecessaryLeadingZeros(this._data.account, this._accountSchemaLength);
  }

  _validateAccount(inputErrors) {
    super._validateAccount();

    const accDigit = this.getAccountDigit(this._data.account).toString();

    if (accDigit !== this._data.account_digit) {
      const newAccount = this._tryDigitInsideAccount();

      if (newAccount) {
        const error = errors.ptBr.dba.INVALID_ACCOUNT;
        const accountError = new ValidationError(
          error.message,
          error.field,
          {
            account: newAccount.account.replace(/^0+/, '')
          },
          error.code
        );

        const error2 = errors.ptBr.dba.ACCOUNT_OR_ACCOUNT_DIGIT_INVALID;
        const accountDigitError = new ValidationError(
          error2.message,
          error2.field,
          {
            account_digit: newAccount.digit
          },
          error2.code
        );

        inputErrors.push(accountError, accountDigitError);
        return;
      }

      const error = errors.ptBr.dba.ACCOUNT_OR_ACCOUNT_DIGIT_INVALID;
      throw new ValidationError(
        error.message,
        error.field,
        {
          account_digit: accDigit
        },
        error.code
      );
    }
  }

  getAccountDigit(account = this._data.account) {
    const d = [
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
      [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
      [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
      [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
      [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
      [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
      [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
      [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
      [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
    ];
    const p = [
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
      [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
      [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
      [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
      [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
      [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
      [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
    ];
    const inv = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

    const invertedArray = this._toInvertedArray(account * 10);
    let check = 0;
    for (let i = 0; i < invertedArray.length; i++) {
      check = d[check][p[i % 8][invertedArray[i]]];
    }
    return inv[check];
  }

  _toInvertedArray(account) {
    return account.toString().split('').map(Number).reverse();
  }

  _tryDigitInsideAccount() {
    const account = this._data.account.substr(0, this._data.account.length - 1);
    const digit = this._data.account.substr(this._data.account.length - 1);

    const accDigit = this.getAccountDigit(account).toString();

    if (accDigit === digit) {
      return {
        account,
        digit
      };
    }

    return null;
  }
};
